import { render, staticRenderFns } from "./dishCategorySort.vue?vue&type=template&id=03753ac8&scoped=true"
import script from "./dishCategorySort.vue?vue&type=script&lang=js"
export * from "./dishCategorySort.vue?vue&type=script&lang=js"
import style0 from "./dishCategorySort.vue?vue&type=style&index=0&id=03753ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03753ac8",
  null
  
)

export default component.exports